"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPolygonZkEVMBridge__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "AlreadyClaimed",
        type: "error",
    },
    {
        inputs: [],
        name: "AmountDoesNotMatchMsgValue",
        type: "error",
    },
    {
        inputs: [],
        name: "DestinationNetworkInvalid",
        type: "error",
    },
    {
        inputs: [],
        name: "EtherTransferFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "GlobalExitRootInvalid",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSmtProof",
        type: "error",
    },
    {
        inputs: [],
        name: "MessageFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "MsgValueNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NotValidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotValidOwner",
        type: "error",
    },
    {
        inputs: [],
        name: "NotValidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "NotValidSpender",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPolygonZkEVM",
        type: "error",
    },
    {
        inputs: [],
        name: "activateEmergencyState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "destinationAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                internalType: "bool",
                name: "forceUpdateGlobalExitRoot",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "permitData",
                type: "bytes",
            },
        ],
        name: "bridgeAsset",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "destinationNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "destinationAddress",
                type: "address",
            },
            {
                internalType: "bool",
                name: "forceUpdateGlobalExitRoot",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "bridgeMessage",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[32]",
                name: "smtProof",
                type: "bytes32[32]",
            },
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "mainnetExitRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "rollupExitRoot",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "originNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "originTokenAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "destinationNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "destinationAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "claimAsset",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32[32]",
                name: "smtProof",
                type: "bytes32[32]",
            },
            {
                internalType: "uint32",
                name: "index",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "mainnetExitRoot",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "rollupExitRoot",
                type: "bytes32",
            },
            {
                internalType: "uint32",
                name: "originNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "originAddress",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "destinationNetwork",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "destinationAddress",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "metadata",
                type: "bytes",
            },
        ],
        name: "claimMessage",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "deactivateEmergencyState",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateGlobalExitRoot",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class IPolygonZkEVMBridge__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.IPolygonZkEVMBridge__factory = IPolygonZkEVMBridge__factory;
IPolygonZkEVMBridge__factory.abi = _abi;
//# sourceMappingURL=IPolygonZkEVMBridge__factory.js.map